import React from 'react';
import { connect } from 'react-redux';
import { PLUS_ICON, MINUS_ICON } from '../../constants/images';
import { MAGIC_NUMBER } from '../../constants/magicNumbers';

import { updateFilters } from '../search/actions';

const mapStateToProps = state => ({
  search: state.Search
});

export const PlusMinusQuantity = (getValue, onChange) => {
  return (
    <div>
      <div className="quantity-input">
        <input className="quantity-input__screen" type="text" value={getValue()} readOnly />
        <button type="button" className="quantity-input__modifier quantity-input__modifier--left" onClick={() => { onChange(-1) }}>
          <img src={MINUS_ICON} alt="minus" className="icon-image" />
        </button>
        <button type="button" className="quantity-input__modifier quantity-input__modifier--right" onClick={() => { onChange(1) }}>
          <img src={PLUS_ICON} alt="plus" className="icon-image" />
        </button>
      </div>
    </div>
  )
}

class RoomsQuantity extends React.Component {
  constructor(props) {
    super(props);

    this.onChange = this.onChange.bind(this);
    this.getValue = this.getValue.bind(this);
  }

  onChange = (increment) => {
    const { dispatch } = this.props;

    const { filters } = this.props.search;

    const newFilters = { ...filters };

    let bedRooms = filters.bedrooms + increment;

    bedRooms = Math.min(bedRooms, MAGIC_NUMBER.MAX_ROOMS);
    bedRooms = Math.max(bedRooms, 0);

    newFilters.bedrooms = bedRooms;

    dispatch(updateFilters(newFilters));
  }

  getValue = () => {
    const { bedrooms } = this.props.search.filters;

    if (bedrooms > 0)
      return `${bedrooms} Bedroom${bedrooms === 1 ? '' : 's'}`;

    return "No. of Rooms";
  }

  render() {
    return PlusMinusQuantity(this.getValue, this.onChange);
  }
}

export default connect(mapStateToProps)(RoomsQuantity);
